import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { AbTestDirective } from '@x/common/ab-test/ab-test.directive';
import { MediaThumbnailComponent } from '@x/common/media-thumbnail/media-thumbnail.component';
import { AssociationModule } from '@x/ecommerce-shop/app/core/association/association.module';
import { AddToCartNotificationOverlayComponent } from '@x/ecommerce-shop/app/core/shop-overlay/components/add-to-cart-notification-overlay/add-to-cart-notification-overlay.component';
import { ShopOverlayService } from '@x/ecommerce-shop/app/core/shop-overlay/shop-overlay.service';
import { CloseButtonModule } from '@x/ecommerce-shop/app/core/shop-ui/components/close-button/close-button.module';

@NgModule({
  providers: [ShopOverlayService],
  declarations: [AddToCartNotificationOverlayComponent],
  imports: [
    CommonModule,
    AssociationModule,
    CloseButtonModule,
    MatButtonModule,
    AbTestDirective,
    MediaThumbnailComponent,
  ],
})
export class ShopOverlayModule {}
